module.exports = __webpack_public_path__ + "img/Screenshot_Toodego.46b09527.svg";